import React from "react";
import moment from "moment";
import styles from "./stockStyles";

const ArticleSection = ({ articles }) => {
  return (
    <div style={styles.articlesFixed}>
      {articles &&
        articles.length > 0 &&
        articles.map((article, mKey) => {
          return (
            <div key={mKey} style={styles.newsContainer}>
              <div>
                <img style={styles.leftNewsPic} src={article.image_url} alt="" />
              </div>
              <div style={styles.rightNews}>
                <a href={article.news_url} target='_blank'>
                  {article.title.length > 50
                    ? article.title.substring(0, 49) + "..."
                    : article.title}
                </a>
              </div>
              <div style={{ fontSize: "0.8rem" }}>
                {moment(article.date).format("MM/DD/YYYY")}
                {" | By: " + article.source_name + " | "}
                <span
                  style={
                    article.sentiment === "Neutral"
                      ? { color: "gray" }
                      : article.sentiment === "Negative"
                      ? { color: "red" }
                      : { color: "green" }
                  }>
                  {article.sentiment}
                </span>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default ArticleSection;



// WEBPACK FOOTER //
// ./src/Pages/Stock/articleSection.js